import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { getAppTheme } from '../services/appTheme';
import { ErrorBoundary } from '../services/bugsnag';
import { StyledContainer } from './atoms/StyledContainer';
import Error from './molecules/Error';
import { ToastProvider } from './organisms/toast';
import { createInertiaApp } from '@inertiajs/react';
// Webpack's require.context (manually declared in d.ts file)
const pages = require.context('./pages', true, /^(?!.*(__tests__|\.test)).*\.tsx$/);
createInertiaApp({
    id: 'app',
    resolve: name => {
        const page = pages(`./${name}.tsx`);
        return page.default;
    },
    setup: ({ el, App, props }) => {
        const appTheme = getAppTheme();
        ReactDOM.render(_jsx(ThemeProvider, { theme: appTheme, children: _jsx(StyledContainer, { children: _jsx(ErrorBoundary, { FallbackComponent: Error, children: _jsx(ToastProvider, { children: _jsx(App, { ...props }) }) }) }) }), el);
    },
});
